module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("47Ijl"))).then(() => parcelRequire('iDabs'));